<template>
  <div class="demo2-container">
    <SkeletonLoader v-if="loading" :loading="loading" />
    <div v-else class="content-wrapper animate__animated animate__fadeIn">
      <!-- 轮播图 -->
      <div class="hero-section" :class="{ 'animate__animated animate__fadeIn': heroSectionVisible }">
        <el-carousel
          height="100vh"
          direction="vertical"
          :autoplay="true"
          :interval="6000"
        >
          <el-carousel-item v-for="item in carouselData" :key="item.id">
            <div class="hero-slide" :style="{ backgroundImage: `url(${item.resource_path})` }">
              <div class="hero-overlay"></div>
              <div class="hero-content container">
                <h2 class="animate__animated animate__fadeInLeft">{{ item.title.split('：')[0] }}</h2>
                <h3 class="animate__animated animate__fadeInLeft">{{ item.title.split('：')[1] }}</h3>
<!--                <p class="animate__animated animate__fadeInLeft animate__delay-1s">{{ t('index.hero_subtitle') }}</p>-->
<!--                <div class="hero-actions animate__animated animate__fadeInUp animate__delay-2s">-->
<!--                  <el-button type="success" size="large" round>{{ t('index.explore_more') }}</el-button>-->
<!--                  <el-button type="info" size="large" round plain>{{ t('index.watch_video') }}</el-button>-->
<!--                </div>-->
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 业务介绍 -->
      <section
        class="business-section"
        :class="{ 'animate__animated animate__fadeIn': businessSectionVisible }"
        v-if="businessData.mining_business || businessData.explosives_business"
      >
        <div class="leaf-bg"></div>
        <div class="container">
          <div class="section-title" :class="{ 'animate__animated animate__fadeInUp': sectionTitleVisible }">
            <span>{{ t('index.our_business_en') }}</span>
            <h2>{{ t('index.ecology_technology') }}</h2>
          </div>

          <div class="business-cards">
            <!-- 矿山业务 -->
            <div
              class="b-card mining"
              :class="{ 'animate__animated animate__fadeInLeft': miningCardVisible }"
              v-if="businessData.mining_business"
            >
              <div class="card-img">
                <img
                  :src="miningBusinessImage || businessImages[0]"
                  :alt="t('index.mining_business')"
                  class="lazy-img"
                  @error="handleImageError('mining')"
                >
              </div>
              <div class="card-content">
                <h3>{{ businessData.mining_business?.page_name || t('index.mining_business') }}</h3>
                <p>{{ miningBusinessText }}</p>
                <router-link
                  :to="`/business/mining`"
                  class="link-arrow"
                  :title="t('index.learn_more')"
                >
                  {{ t('index.learn_more') }} <el-icon><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>

            <!-- 矿山建设 -->
            <div
              class="b-card mining_c"
              :class="{ 'animate__animated animate__fadeInRight': miningConstructionCardVisible }"
              v-if="businessData.mine_construction"
            >
              <div class="card-img">
                <img
                  :src="miningConstructionImage || businessImages[1]"
                  :alt="t('index.mining_business')"
                  class="lazy-img"
                  @error="handleImageError('mining')"
                >
              </div>
              <div class="card-content">
                <h3>{{ businessData.mine_construction?.page_name || t('index.mine_construction') }}</h3>
                <p>{{ mineConstruction }}</p>
                <router-link
                  :to="`/business/mine-construction`"
                  class="link-arrow"
                  :title="t('index.learn_more')"
                >
                  {{ t('index.learn_more') }} <el-icon><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>
            <!-- 民爆业务 -->
            <div
              class="b-card explosives"
              :class="{ 'animate__animated animate__fadeInLeft': explosivesCardVisible }"
              v-if="businessData.explosives_business"
            >
              <div class="card-img">
                <img
                  :src="explosivesBusinessImage || businessImages[2]"
                  :alt="t('index.explosives_business')"
                  class="lazy-img"
                  @error="handleImageError('explosives')"
                >
              </div>
              <div class="card-content">
                <h3>{{ businessData.explosives_business?.page_name || t('index.explosives_business') }}</h3>
                <p>{{ explosivesBusinessText }}</p>
                <router-link
                  :to="`/business/explosives`"
                  class="link-arrow"
                  :title="t('index.learn_more')"
                >
                  {{ t('index.learn_more') }} <el-icon><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 新闻动态 -->
      <section
        class="news-section"
        :class="{ 'animate__animated animate__fadeIn': newsSectionVisible }"
        v-if="homeData.news && homeData.news.length > 0"
      >
        <div class="container">
          <div
            class="section-header"
            :class="{ 'animate__animated animate__fadeInDown': newsHeaderVisible }"
          >
            <h2 style="color: #333333">{{ t('index.latest_news') }}</h2>
            <router-link to="/news" class="view-all">{{ t('index.view_all') }}</router-link>
          </div>

          <div class="news-slider">
            <div
              v-for="(item, index) in homeData.news"
              :key="item.id"
              class="news-card"
              :class="{ 'animate__animated animate__fadeInUp': newsCardsVisible[index] }"
              :style="`animation-delay: ${index * 0.1}s`"
              @click="handleNewsClick(item)"
              :title="item.external_link ? t('index.new_window') : t('index.click_to_view')"
            >
              <div class="news-img">
                <img
                  v-if="item.cover_image"
                  v-lazy="getImageUrl(item.cover_image)"
                  :alt="item.title"
                  class="lazy-img"
                >
                <div v-else class="news-img-placeholder">
                  <el-icon size="40"><Document /></el-icon>
                </div>
                <span class="news-tag">{{ getCategoryName(item.category) }}</span>
              </div>
              <div class="news-body">
                <span class="date">{{ formatDate(item.publish_time) }}</span>
                <h4>{{ item.title }}</h4>
                <p>{{ truncateText(item.summary || t('index.placeholder_no_summary'), 60) }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 公告与报表 -->
      <section
        class="notice-section"
        :class="{ 'animate__animated animate__fadeIn': noticeSectionVisible }"
        v-if="homeData.notices && homeData.notices.length > 0"
      >
        <div class="container">
          <div
            class="section-header"
            :class="{ 'animate__animated animate__fadeInDown': noticeHeaderVisible }"
          >
            <h2>{{ t('index.announcements_reports') }}</h2>
            <router-link to="/notice" class="view-all">{{ t('index.view_all') }}</router-link>
          </div>

          <div class="notice-grid">
            <div
              v-for="(item, index) in homeData.notices"
              :key="item.id"
              class="notice-card"
              :class="getNoticeCardClass(index)"
              :style="`animation-delay: ${index * 0.1}s`"
              @click="goToNoticeDetail(item.id)"
              :title="t('index.click_to_view')"
            >
              <div class="notice-icon-wrapper">
                <el-icon class="notice-icon">
                  <Document />
                </el-icon>
              </div>
              <div class="notice-content">
                <div class="notice-category">
                  {{ getCategoryName(item.category) }}
                </div>
                <h4 class="notice-title">{{ item.title }}</h4>
                <p class="notice-summary">{{ truncateText(item.summary || t('index.placeholder_no_summary'), 80) }}</p>
                <div class="notice-footer">
                  <span class="notice-date">{{ formatDate(item.publish_time) }}</span>
                  <el-icon class="arrow-icon"><ArrowRight /></el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, inject, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SkeletonLoader from '@/components/SkeletonLoader.vue';
import {
  ArrowRight,
  Picture,
  Document,
  DataAnalysis,
  Files
} from '@element-plus/icons-vue';
import { getHomeConfigApi } from '@/assets/api/website';

// 使用i18n
const { locale, t } = useI18n();
const router = useRouter();
const route = useRoute();

// 注入布局组件的方法
const layout = inject<{ triggerFooterAnimation: () => void }>('layout', {
  triggerFooterAnimation: () => {}
});

const loading = ref(true);
const homeData = ref<any>({});
const businessData = ref<any>({});

// 动画可见性状态
const heroSectionVisible = ref(false);
const businessSectionVisible = ref(false);
const sectionTitleVisible = ref(false);
const miningCardVisible = ref(false);
const miningConstructionCardVisible = ref(false);
const explosivesCardVisible = ref(false);
const newsSectionVisible = ref(false);
const newsHeaderVisible = ref(false);
const noticeSectionVisible = ref(false);
const noticeHeaderVisible = ref(false);

// 保留轮播图数据（暂时不动）
const carouselData = ref([
  {
    id: 1,
    title: t('index.mining_business'),
    // Vite中用new URL解析别名，返回完整的资源路径
    resource_path: new URL('@/assets/img/banner5.webp', import.meta.url).href
  },
  {
    id: 2,
    title: t('index.explosives_business'),
    resource_path: new URL('@/assets/img/banner2.webp', import.meta.url).href
  },
  {
    id: 3,
    title: t('index.our_business'),
    resource_path: new URL('@/assets/img/banner3.webp', import.meta.url).href
  }
]);
const businessImages = ref<string[]>([
  new URL('@/assets/img/mb.png', import.meta.url).href,
  new URL('@/assets/img/mc.png', import.meta.url).href,
  new URL('@/assets/img/eb.png', import.meta.url).href,
]);

const newsCardsVisible = ref<boolean[]>([]);
const noticeCardsVisible = ref<boolean[]>([]);

// 从content对象中提取富文本内容
const extractRichText = (content: any): string => {
  if (!content) return '';
  if (typeof content === 'string') return content;
  if (content.richtext) return content.richtext;
  return '';
};

// 计算属性：从富文本中提取矿山业务图片
const miningBusinessImage = computed(() => {
  const content = extractRichText(businessData.value.mining_business?.content);
  if (!content) return null;

  try {
    // 从富文本中提取第一张图片
    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/i;
    const match = imgRegex.exec(content);
    return match ? match[1] : null;
  } catch (error) {
    console.error('解析矿山业务图片失败:', error);
    return null;
  }
});
// 计算属性：从富文本中提取矿山业务图片
const miningConstructionImage = computed(() => {
  const content = extractRichText(businessData.value.mine_construction?.content);
  if (!content) return null;

  try {
    // 从富文本中提取第一张图片
    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/i;
    const match = imgRegex.exec(content);
    return match ? match[1] : null;
  } catch (error) {
    console.error('解析矿山业务图片失败:', error);
    return null;
  }
});
// 计算属性：从富文本中提取矿山业务文字（剔除图片和HTML标签）
const miningBusinessText = computed(() => {
  const content = extractRichText(businessData.value.mining_business?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    // 移除图片标签
    let text = content.replace(/<img[^>]*>/gi, '');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 计算属性：从富文本中提取矿山业务文字（剔除图片和HTML标签）
const mineConstruction = computed(() => {
  const content = extractRichText(businessData.value.mine_construction?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    // 移除图片标签
    let text = content.replace(/<img[^>]*>/gi, '');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 计算属性：从富文本中提取民爆业务图片
const explosivesBusinessImage = computed(() => {
  const content = extractRichText(businessData.value.explosives_business?.content);
  if (!content) return null;

  try {
    // 从富文本中提取第一张图片
    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/i;
    const match = imgRegex.exec(content);
    return match ? match[1] : null;
  } catch (error) {
    console.error('解析民爆业务图片失败:', error);
    return null;
  }
});

// 计算属性：从富文本中提取民爆业务文字
const explosivesBusinessText = computed(() => {
  const content = extractRichText(businessData.value.explosives_business?.content);
  if (!content) return t('index.fallback_description_explosives');

  try {
    // 移除图片标签
    let text = content.replace(/<img[^>]*>/gi, '');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析民爆业务文本失败:', error);
    return t('index.fallback_description_explosives');
  }
});

// 工具函数：获取完整的图片URL
const getImageUrl = (imagePath: string) => {
  if (!imagePath) return '';
  // 如果已经是完整URL，直接返回
  if (imagePath.startsWith('http')) return imagePath;
  // 否则添加基础路径
  return `${imagePath}`;
};

// 工具函数：获取分类名称
const getCategoryName = (category: any) => {
  if (!category || !category.name) return t('index.news');

  // 根据分类名称返回对应的国际化文本
  switch (category.name) {
    case '集团新闻':
      return t('index.category_news');
    case '财务报表':
      return t('index.category_financial');
    case '股本申报表':
      return t('index.category_capital');
    case '公告及通函':
      return t('index.category_announcements');
    default:
      return category.name;
  }
};

// 检查是否为公告类别
const isNoticeCategory = (category: any) => {
  if (!category) return true;
  return category.name === '公告及通函';
};

// 检查是否为报表类别
const isReportCategory = (category: any) => {
  if (!category) return false;
  return category.name === '财务报表';
};

// 工具函数：格式化日期
const formatDate = (dateString: string) => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    // 根据不同语言使用不同的日期格式
    const formatKey = 'index.date_format';
    if (t(formatKey) !== formatKey) {
      return t(formatKey, { year, month, day });
    }

    // 如果翻译不存在，使用默认格式
    switch (locale.value) {
      case 'en':
        return `${month}/${day}/${year}`;
      case 'ru':
        return `${day}.${month}.${year}`;
      default:
        return `${year}年${month}月${day}日`;
    }
  } catch (error) {
    console.error('日期格式化错误:', error);
    return dateString;
  }
};

// 工具函数：截断文本
const truncateText = (text: string, maxLength: number) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

const getNoticeCardClass = (index: number) => {
  const baseClass = ['notice-card', 'animate__animated', 'animate__fadeInUp'];
  // 移除notice-card-primary等颜色分类，统一样式
  return baseClass;
};
// 图片加载失败处理
const handleImageError = (type: 'mining' | 'explosives') => {
  console.log(`${type} ${t('index.error_loading')}`);
};

// 新闻点击处理
const handleNewsClick = (item: any) => {
  if (item.external_link) {
    // 如果有external_link，在新标签页打开
    window.open(item.external_link, '_blank');
  } else {
    // 否则跳转到新闻详情页
    router.push(`/news/${item.id}?lang=${locale.value}`);
  }
};

// 跳转到公告详情
const goToNoticeDetail = (id: number) => {
  router.push(`/notice/${id}?lang=${locale.value}`);
};

// 加载首页数据
const loadHomeData = async () => {
  try {
    loading.value = true;

    const response = await getHomeConfigApi({ lang: locale.value });
    if (response) {
      carouselData.value[0].title = response.mining_business.page_name;
      carouselData.value[1].title = response.mine_construction.page_name;
      carouselData.value[2].title = response.explosives_business.page_name;
      homeData.value = response;
      businessData.value = {
        mining_business: response.mining_business,
        explosives_business: response.explosives_business,
        mine_construction: response.mine_construction,
      };

      // 初始化动画状态数组
      if (response.news) {
        newsCardsVisible.value = Array(response.news.length).fill(false);
      }
      if (response.notices) {
        noticeCardsVisible.value = Array(response.notices.length).fill(false);
      }
    }
  } catch (error) {
    console.error(`${t('index.error_loading')}:`, error);
  } finally {
    loading.value = false;
    heroSectionVisible.value = true;

    // 初始触发一次动画检查
    setTimeout(() => {
      triggerScrollAnimations();
    }, 100);
  }
};

// 监听语言变化
watch(locale, () => {
  loadHomeData();
});

const handleScroll = () => {
  triggerScrollAnimations();
};

// 检查元素是否在视窗内
const isElementInViewport = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;

  if (element.classList.contains('footer')) {
    return rect.top <= windowHeight + 100;
  }

  return (
    rect.top <= windowHeight * 0.8 &&
    rect.bottom >= 0
  );
};

// 滚动动画触发函数
const triggerScrollAnimations = () => {
  // Hero Section
  const heroSection = document.querySelector('.hero-section');
  if (heroSection && isElementInViewport(heroSection as HTMLElement)) {
    heroSectionVisible.value = true;
  }

  // Business Section
  const businessSection = document.querySelector('.business-section');
  if (businessSection && isElementInViewport(businessSection as HTMLElement)) {
    businessSectionVisible.value = true;

    const sectionTitle = document.querySelector('.section-title');
    if (sectionTitle && isElementInViewport(sectionTitle as HTMLElement)) {
      sectionTitleVisible.value = true;
    }

    const miningCard = document.querySelector('.b-card.mining');
    if (miningCard && isElementInViewport(miningCard as HTMLElement)) {
      miningCardVisible.value = true;
    }
    const mining_C_Card = document.querySelector('.b-card.mining_c');
    if (mining_C_Card && isElementInViewport(mining_C_Card as HTMLElement)) {
      miningConstructionCardVisible.value = true;
    }
    const explosivesCard = document.querySelector('.b-card.explosives');
    if (explosivesCard && isElementInViewport(explosivesCard as HTMLElement)) {
      explosivesCardVisible.value = true;
    }
  }

  // News Section
  const newsSection = document.querySelector('.news-section');
  if (newsSection && isElementInViewport(newsSection as HTMLElement)) {
    newsSectionVisible.value = true;

    const newsHeader = document.querySelector('.news-section .section-header');
    if (newsHeader && isElementInViewport(newsHeader as HTMLElement)) {
      newsHeaderVisible.value = true;
    }

    const newsCards = document.querySelectorAll('.news-section .news-card');
    newsCards.forEach((card, index) => {
      if (isElementInViewport(card as HTMLElement)) {
        newsCardsVisible.value[index] = true;
      }
    });
  }

  // Notice Section
  const noticeSection = document.querySelector('.notice-section');
  if (noticeSection && isElementInViewport(noticeSection as HTMLElement)) {
    noticeSectionVisible.value = true;

    const noticeHeader = document.querySelector('.notice-section .section-header');
    if (noticeHeader && isElementInViewport(noticeHeader as HTMLElement)) {
      noticeHeaderVisible.value = true;
    }

    const noticeCards = document.querySelectorAll('.notice-section .notice-card');
    noticeCards.forEach((card, index) => {
      if (isElementInViewport(card as HTMLElement)) {
        noticeCardsVisible.value[index] = true;
      }
    });
  }

  // Footer 动画触发
  const footerSection = document.querySelector('.footer');
  if (footerSection) {
    const rect = footerSection.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isFooterInView = rect.top <= windowHeight + 100;
    const isScrollToBottom = window.scrollY + windowHeight >= document.body.offsetHeight - 100;

    if (isFooterInView || isScrollToBottom) {
      layout.triggerFooterAnimation();
    }
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  loadHomeData();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
/* 首页特有样式 */
.demo2-container {
  width: 100%;
}

.content-wrapper {
  width: 100%;
}

/* Hero 区域 */
.hero-section {
  position: relative;
  opacity: 0;
  transition: opacity 1s ease;
}

.hero-slide {
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.2);
}

.hero-content {
  position: relative;
  z-index: 2;
  color: #fff;
  max-width: 800px;
}

.hero-content h2 {
  font-family: 'Merriweather', serif;
  font-size: 64px;
  margin-bottom: 20px;
  line-height: 1.2;
}


.hero-content h3 {
  font-family: 'Merriweather', serif;
  font-size: 48px;
  margin-bottom: 20px;
  line-height: 1.2;
}

.hero-content p {
  font-size: 20px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.hero-actions {
  display: flex;
  gap: 20px;
}

/* Business Section */
.business-section {
  padding: 100px 0;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.8s ease;
}

.leaf-bg {
  position: absolute;
  top: -100px;
  right: -100px;
  width: 400px;
  height: 400px;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTlmN2VmIiBzdHJva2Utd2lkdGg9IjEiPjxwYXRoIGQ9Ik0yIDJjMTAgMCAyMCAxMCAyMCAyMHMtMTAgMjAtMjAgMjBTMiAzMiAyIDIyIDEyIDIgMiAyeiIvPjwvc3ZnPg==');
  background-size: contain;
  opacity: 0.5;
  z-index: 0;
}

.section-title {
  text-align: center;
  margin-bottom: 80px;
  position: relative;
  z-index: 1;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.section-title span {
  color: #67c23a;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 12px;
  display: block;
  margin-bottom: 10px;
}

.section-title h2 {
  font-family: 'Merriweather', serif;
  font-size: 36px;
  color: #2c5e2e;
  margin: 0;
}

.business-cards {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.b-card {
  display: flex;
  align-items: center;
  gap: 60px;
  opacity: 0;
  transition: opacity 0.8s ease;
}

.b-card:nth-child(even) {
  flex-direction: row-reverse;
}

.card-img {
  flex: 1;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(44, 94, 46, 0.1);
}

.card-img img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  transition: transform 0.6s ease;
  opacity: 1 !important;
}

.b-card:hover .card-img img {
  transform: scale(1.05);
}

.card-content {
  flex: 1;
}

.card-content h3 {
  font-family: 'Merriweather', serif;
  font-size: 32px;
  color: #2c5e2e;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease 0.3s;
}

.b-card.animate__animated .card-content h3 {
  opacity: 1;
  transform: translateY(0);
}

.card-content p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 30px;
  font-size: 16px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease 0.4s;
}

.b-card.animate__animated .card-content p {
  opacity: 1;
  transform: translateY(0);
}

.link-arrow {
  color: #2c5e2e;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s;
  opacity: 0;
  transform: translateX(-20px);
  transition: all 0.8s ease 0.5s;
}

.b-card.animate__animated .link-arrow {
  opacity: 1;
  transform: translateX(0);
}

.link-arrow:hover {
  gap: 10px;
  color: #67c23a;
}

/* ESG Section */
.esg-section {
  background-color: #2c5e2e;
  color: #fff;
  padding: 100px 0;
  background-image: url('https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?q=80&w=2070&auto=format&fit=crop');
  background-blend-mode: multiply;
  background-size: cover;
  opacity: 0;
  transition: opacity 0.8s ease;
}

.esg-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.esg-info {
  opacity: 0;
  transform: translateX(-50px);
  transition: all 0.8s ease;
}

.esg-info h2 {
  font-family: 'Merriweather', serif;
  font-size: 42px;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.esg-info.animate__animated h2 {
  opacity: 1;
  transform: translateY(0);
}

.esg-info p {
  font-size: 18px;
  opacity: 0.9;
  margin-bottom: 30px;
  line-height: 1.6;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease 0.2s;
}

.esg-info.animate__animated p {
  opacity: 1;
  transform: translateY(0);
}

.esg-list {
  list-style: none;
  padding: 0;
  margin-bottom: 40px;
}

.esg-list li {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  font-size: 18px;
  opacity: 0;
  transform: translateX(-20px);
}

.esg-list li.animate__animated {
  opacity: 1;
  transform: translateX(0);
  animation-duration: 0.6s;
}

.esg-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.stat-box {
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid rgba(255,255,255,0.2);
  transition: all 0.3s;
  opacity: 0;
  transform: scale(0.8);
}

.stat-box.animate__animated {
  opacity: 1;
  transform: scale(1);
  animation-duration: 0.8s;
}

.stat-box:hover {
  transform: translateY(-5px) scale(1.05);
  background: rgba(255,255,255,0.15);
}

.stat-box .number {
  display: block;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #a3e635;
}

.stat-box .label {
  font-size: 14px;
  opacity: 0.8;
}

/* News Section */
.news-section {
  padding: 100px 0;
  opacity: 0;
  transition: opacity 0.8s ease;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 50px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
}

.section-header h2 {
  font-family: 'Merriweather', serif;
  font-size: 36px;
  color: #2c5e2e;
  margin: 0;
}

.view-all {
  color: #666;
  text-decoration: none;
  border-bottom: 1px solid #ccc;
  padding-bottom: 2px;
  transition: all 0.3s;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.6s ease 0.3s;
}

.section-header.animate__animated .view-all {
  opacity: 1;
  transform: translateX(0);
}

.view-all:hover {
  color: #2c5e2e;
  border-color: #2c5e2e;
}

.news-slider {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.news-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  transition: all 0.3s;
  opacity: 0;
  transform: translateY(30px);
}

.news-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.news-img {
  height: 200px;
  position: relative;
  overflow: hidden;
}

.news-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.news-card:hover .news-img img {
  transform: scale(1.05);
}

.news-tag {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #fff;
  color: #2c5e2e;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
}

.news-body {
  padding: 25px;
}

.news-body .date {
  font-size: 12px;
  color: #999;
  display: block;
  margin-bottom: 10px;
}

.news-body h4 {
  font-size: 18px;
  margin: 0 0 10px;
  color: #333;
  line-height: 1.4;
}

.news-body p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

/* 响应式样式 */
@media (max-width: 1024px) {
  .news-slider {
    grid-template-columns: repeat(2, 1fr);
  }

  .esg-grid {
    gap: 40px;
  }

  .hero-content h2 {
    font-size: 48px;
  }
}

@media (max-width: 768px) {
  .b-card, .b-card:nth-child(even) {
    flex-direction: column;
    gap: 30px;
  }

  .card-img img {
    height: 300px;
  }

  .esg-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .news-slider {
    grid-template-columns: 1fr;
  }

  .hero-content h2 {
    font-size: 36px;
  }

  .hero-content p {
    font-size: 16px;
  }

  .hero-actions {
    flex-direction: column;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .section-title h2 {
    font-size: 28px;
  }

  .card-content h3 {
    font-size: 24px;
  }

  .esg-info h2 {
    font-size: 32px;
  }
}
/* 保持原有的CSS样式不变，只添加新的样式 */

.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #999;
  gap: 10px;
  background: #f5f5f5;
}

.image-placeholder .el-icon {
  color: #ccc;
}

.news-img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  opacity: 0.7;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.news-card, .notice-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.news-card:hover h4 {
  color: #2c5e2e;
}


.notice-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #1a2b3c 0%, #2c3e50 100%);
  position: relative;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.8s ease;
}

/* 添加深色背景装饰 */
.notice-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJyZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=');
  opacity: 0.3;
}

.section-header h2 {
  color: #ffffff;
  font-family: 'Merriweather', serif;
  font-size: 36px;
  margin: 0;
  position: relative;
  z-index: 1;
}

.section-header .view-all {
  color: #a3b1c2;
  text-decoration: none;
  border-bottom: 1px solid rgba(163, 177, 194, 0.3);
  padding-bottom: 2px;
  transition: all 0.3s;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.6s ease 0.3s;
}

.section-header.animate__animated .view-all {
  opacity: 1;
  transform: translateX(0);
}

.view-all:hover {
  color: #ffffff;
  border-color: #ffffff;
}

.notice-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 24px;
  margin-top: 50px;
}

.notice-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 28px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  opacity: 0;
  transform: translateY(30px);
  position: relative;
  overflow: hidden;
  z-index: 1;
}

/* 添加卡片悬停效果 */
.notice-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.notice-card:hover::before {
  opacity: 1;
}

.notice-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
}

.notice-icon-wrapper {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.notice-icon {
  font-size: 28px;
  color: #ffffff;
}

.notice-content {
  flex: 1;
  min-width: 0; /* 防止文本溢出 */
}

.notice-category {
  font-size: 12px;
  color: #a3b1c2;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
  font-weight: 600;
  display: inline-block;
  padding: 4px 12px;
  background: rgba(163, 177, 194, 0.1);
  border-radius: 20px;
}

.notice-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 14px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.3s ease;
}

.notice-card:hover .notice-title {
  color: #67c23a;
}

.notice-summary {
  font-size: 14px;
  color: #a3b1c2;
  line-height: 1.6;
  margin: 0 0 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.notice-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 16px;
  margin-top: auto;
}

.notice-date {
  font-size: 12px;
  color: #8a9aad;
}

.arrow-icon {
  color: #a3b1c2;
  transition: all 0.3s ease;
}

.notice-card:hover .arrow-icon {
  color: #ffffff;
  transform: translateX(5px);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .notice-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .notice-section {
    padding: 60px 0;
  }

  .section-header h2 {
    font-size: 28px;
  }

  .notice-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .notice-card {
    padding: 20px;
  }

  .notice-icon-wrapper {
    width: 48px;
    height: 48px;
  }

  .notice-icon {
    font-size: 24px;
  }

  .notice-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .notice-section {
    padding: 40px 0;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .notice-card {
    flex-direction: column;
    gap: 16px;
  }

  .notice-icon-wrapper {
    width: 56px;
    height: 56px;
    margin: 0 auto;
  }
}

.link-arrow {
  color: #2c5e2e;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s;
}

.link-arrow:hover {
  gap: 10px;
  color: #67c23a;
}
</style>